import dayjs, { Dayjs } from 'dayjs'

declare global {
  interface Window {
    SERVER: string
  }
}

export const configuration = {
  BASE_API_URL: 'https://iisconnect.api.sandbox.2284systems.com/api',
  // BASE_API_URL: 'http://localhost:9000/api',
  /*import.meta.env.Mode === 'development'
    ? 'http://localhost:9000/api'
    : 'https://iisconnect.api.sandbox.2284systems.com/api',*/
  AUTH_STORE_KEY: 'bZUohbohf+msAQEvHvF2SyUY55zODb8wTfkjmNmXIDmAJ7zxSUPhsu0g3fbB1P4kpXry+08rzo/BJ69lobT4QQ==',
  AUTH_USER_INFO: 'dz/JH6AAigx0oRXLcvUdpY867v80jnaPO/gRKSj3+S0=',
}

export const pascalCase = (word: string) => word[0].toUpperCase() + word.substring(1).toLowerCase()

export const titleCase = (sentence: string) =>
  sentence
    .split(' ')
    .map((word) => pascalCase(word))
    .join(' ')

export const toCurrency = (number: number) =>
  new Intl.NumberFormat('en-us', { style: 'currency', currency: 'USD' }).format(number)

export const sleep = (ms = 0) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

/** Validation */
export const validators = {
  email: (v: string) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return pattern.test(v) || 'Please enter a valid email address'
  },
  required: (v: any) => !!v || 'This field is required',
}

export const rules = {
  minSize: (v: any, size: number, label: string) => v <= size || `${label} should be of minimum size of ${size}`,
  required: (v: any, label: string) =>
    (typeof v === 'string' ? v.trim().length != 0 : !!v) || `${label} is a required field`,
  validEmail: (v: string, label: string) =>
    /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(v) || `${label} is not a valid email`,
  minLength: (v: string, len: number, label: string) =>
    (v ?? '').length >= len || `${label} must contain at least ${len} characters.`,
  maxLength: (v: string, len: number, label: string) =>
    (v ?? '').length <= len || `${label} should be less than ${len} characters`,
  regTest: (v: string, exp: RegExp, message: string) => exp.test(v) || message,
  compareFields: (f1: string, f2: string) => f1 === f2 || 'Passwords must match',
  minDate: (v: any, min: Dayjs) => dayjs(v) > min || 'age cannot be over 100 years',
  maxDate: (v: any, max: Dayjs) => dayjs(v) < max || 'age is required to be over 18 years',
}
